(function() {
  'use strict';

  // A directive to disable ng-animations for ui-select
  angular.module('ringbaPortal').directive('uiSelectNoAnimate', uiSelectNoAnimate);
  
  function uiSelectNoAnimate() {
    const directive = {
      restrict: 'A',
      require: 'uiSelect',
      link: function (scope, element, attrs, $select) {
        $select.$animate = null;
      }
    };

    return directive;
  }
})();